import { render, staticRenderFns } from "./AddManualAllocation.vue?vue&type=template&id=ec829c22&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddManualAllocation.vue"
export default component.exports